import { render, staticRenderFns } from "./skillSection.vue?vue&type=template&id=87ebb0da&scoped=true&"
import script from "./skillSection.vue?vue&type=script&lang=js&"
export * from "./skillSection.vue?vue&type=script&lang=js&"
import style0 from "./skillSection.vue?vue&type=style&index=0&id=87ebb0da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ebb0da",
  null
  
)

export default component.exports